import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';
import { Button } from '../ui/button';
import { dspHubAPI, errMsg } from '../../lib/regulatoryAPI';

const Section = ({ title, empty, rows, render, testId }) => (
  <section className="space-y-2" data-testid={testId}>
    <h3 className="text-sm font-semibold">{title} ({rows.length})</h3>
    {rows.length ? <ul className="space-y-2">{rows.map(render)}</ul> : <p className="text-sm text-muted-foreground">{empty}</p>}
  </section>
);

export const DspAreaDrawer = ({ areaKey, onClose }) => {
  const [a, setA] = useState(null);
  useEffect(() => {
    setA(null);
    if (areaKey) dspHubAPI.area(areaKey).then(setA).catch((e) => toast.error(errMsg(e)));
  }, [areaKey]);
  return (
    <Sheet open={!!areaKey} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-xl" data-testid="dsp-hub-drawer">
        <SheetHeader><SheetTitle>{a?.area || 'Loading…'}</SheetTitle></SheetHeader>
        {a && <div className="mt-4 space-y-6">
          <p className="text-xs text-muted-foreground">{a.rule}</p>
          <Section title="Controls" empty="No controls mapped to this area." rows={a.controls} testId="dsp-hub-drawer-controls" render={(c) => (
            <li key={c.id} className="rounded-md border p-3 text-sm">
              <div className="flex justify-between gap-2"><b>{c.control_id}</b><span className="text-xs">{c.implementation_status}</span></div>
              <p className="text-muted-foreground">{c.requirement}</p>
              <p className="mt-1 text-xs text-muted-foreground">Owner: {c.owner || '—'} · Review: {c.review_date || '—'}</p>
            </li>)} />
          <Section title="Evidence" empty="No evidence linked (by OSF area or control ID)." rows={a.evidence} testId="dsp-hub-drawer-evidence" render={(e) => (
            <li key={e.id} className="rounded-md border p-3 text-sm"><b>{e.title}</b><p className="text-xs text-muted-foreground">{e.date || '—'} · {e.control_ids || e.osf_area}</p></li>)} />
          <Section title="Outstanding actions" empty="None." rows={a.outstanding} testId="dsp-hub-drawer-outstanding" render={(o) => (
            <li key={o.id} className="rounded-md border p-3 text-sm"><b>{o.item}</b> – {o.status}<p className="text-xs text-muted-foreground">{o.action}</p></li>)} />
          <Button variant="outline" asChild data-testid="dsp-hub-drawer-edit"><a href="/settings?tab=dsp">Edit in DSP Compliance Centre</a></Button>
          <p className="text-xs text-muted-foreground">{a.note}</p>
        </div>}
      </SheetContent>
    </Sheet>
  );
};
